import { FC } from 'react'

import Image from 'next/image'

import { arrowForward, iphoneApproval100 } from '@ui/assets'
import { useSignUpHref } from '@ui/layout/signUpHref'

export const TransformCTA: FC = () => {
  const signUpHref = useSignUpHref()
  return (
    <section className="bg-white py-24">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="relative h-auto overflow-hidden rounded-[40px] bg-[#daf1fa] lg:h-[598px]">
          {/* Decorative ellipses - masked to container */}
          <div className="absolute left-[352px] top-[-54px] z-0 hidden opacity-30 lg:block">
            <div className="rotate-[224deg] scale-y-[-100%]">
              <div
                className="h-[1123px] w-[858px] rounded-full"
                style={{
                  background:
                    'linear-gradient(135deg, #29bfed 0%, #006fff 100%)',
                }}
              />
            </div>
          </div>
          <div className="absolute left-[-740px] top-[-766px] z-0 hidden opacity-20 lg:block">
            <div className="rotate-[224deg] scale-y-[-100%]">
              <div
                className="h-[1123px] w-[858px] rounded-full"
                style={{
                  background:
                    'linear-gradient(135deg, #29bfed 0%, #006fff 100%)',
                }}
              />
            </div>
          </div>

          {/* iPhone mockup - right side */}
          <div className="absolute left-[392px] top-[113px] z-[1] hidden h-[831px] w-[1108px] lg:block">
            <Image
              src={iphoneApproval100}
              width={1108}
              height={831}
              alt=""
              className="h-full w-full object-cover"
            />
          </div>

          {/* Content - left side */}
          <div className="relative z-10 flex h-full flex-col justify-start px-6 py-12 sm:px-12 lg:px-[60px] lg:py-[60px]">
            <div className="max-w-[876px]">
              <h2 className="font-display mb-10 text-3xl leading-[1.1] tracking-[-1.2px] text-[#0a2d4a] sm:text-5xl lg:text-[60px]">
                Ready to transform your finances?
              </h2>
              <p className="mb-10 max-w-[456px] text-[19px] leading-[1.4] text-[#0a2d4a]">
                Get instant cash when you need it, earn rewards, and take
                control of your money with smart budgeting tools—all in one app.
              </p>

              <a
                href={signUpHref}
                className="inline-flex items-center gap-4 rounded-full bg-[#0a3754] py-1 pl-6 pr-1 transition-all hover:bg-[#0a3754]/90"
              >
                <span className="text-[17px] font-bold tracking-[-0.34px] text-white">
                  Get Started
                </span>
                <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#29bfed]">
                  <Image src={arrowForward} width={24} height={24} alt="" />
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}
